export type ReportFilenameUser = {
    first_name?: string | null;
    last_name?: string | null;
    middle_name?: string | null;
};

const sanitizeFilePart = (value: string): string =>
    value
        .trim()
        .replace(/[<>:"/\\|?*\s]+/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_|_$/g, '');

const pad2 = (n: number) => String(n).padStart(2, '0');

export const buildReportXlsxFilename = (
    user: ReportFilenameUser | null | undefined,
    createdAt: string | null | undefined,
    reportId: number,
): string => {
    const parts = [user?.last_name, user?.first_name, user?.middle_name]
        .filter((p): p is string => Boolean(p && String(p).trim()))
        .map((p) => sanitizeFilePart(String(p)));
    const name = parts.join('_') || 'user';

    if (!createdAt) {
        return `${name}_${reportId}_unknown-date.xlsx`;
    }
    const d = new Date(createdAt);
    if (Number.isNaN(d.getTime())) {
        return `${name}_${reportId}_unknown-date.xlsx`;
    }
    const datePart = `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
    const timePart = `${pad2(d.getHours())}-${pad2(d.getMinutes())}-${pad2(d.getSeconds())}`;

    return `${name}_${reportId}_${datePart}_${timePart}.xlsx`;
};

export const parseFilenameFromContentDisposition = (
    header: string | null,
): string | null => {
    if (!header) return null;
    const match = /filename\*?=(?:UTF-8''|")?([^";\n]+)"?/i.exec(header);
    return match?.[1]?.trim() || null;
};
